import { Component, OnInit } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { PersonSelectorService } from "../../personselector/personselector.service";
import { AddMealComponent } from "./add-meal/add-meal.component";
import { DataService_StudentMeals } from "./shared/data.service";

@Component({
	selector: "app-student-meals",
	templateUrl: "./student-meals.component.html",
	styleUrls: ["./student-meals.component.css"],
})
export class StudentMealsComponent implements OnInit {
	constructor(
		private selectService: PersonSelectorService,
		private userService: UserService,
		private MealsService: DataService_StudentMeals,
		private dialogService: DialogService
	) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.subscription = this.selectService.onPersonSelectChange().subscribe((person) => {
			this.SelectedPerson = person;
			this.loadResult();
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	SelectedPerson: any;

	subscription: any;

	processing: any = false;

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedResult: any;
	lstResult: any = [];

	//Filter lists
	lstAccountTypeCD: any = [];
	lstMealTypeDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "FineDTDesc", header: "Date/Time" },
		{ field: "AccountTypeCD", header: "Transaction" },
		{ field: "MealTypeDesc", header: "Meal Type" },
		{ field: "ChargedDesc", header: "Charged" },
		{ field: "AdjustedDesc", header: "Adjusted" },
		{ field: "PaidDesc", header: "Paid" },
		{ field: "BalanceDesc", header: "Balance" },
	];

	///////////////

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadResult() {
		this.errorMessage = "";

		this.SelectedResult = [];

		if (this.SelectedPerson == undefined) {
			this.lstResult = [];
			this.lstAccountTypeCD = [];
			this.lstMealTypeDesc = [];
		}

		this.loading = true;

		var result = this.MealsService.MealHistorySelectList(this.SelectedPerson.PersonID);
		result.subscribe(
			(response) => {
				this.lstResult = response;

				//Load Data Filter Lists
				this.lstAccountTypeCD = Array.from(new Set(this.lstResult.map((item: any) => item.AccountTypeCD))).sort();
				this.lstMealTypeDesc = Array.from(new Set(this.lstResult.map((item: any) => item.MealTypeDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////

	onRefresh() {
		this.loadResult();
	}

	//Custom Button Methods
	onAddMeal() {
		this.errorMessage = "";

		if (this.SelectedPerson == undefined) {
			this.errorMessage = "Select a person to add meals";
			return;
		}

		var ref = this.dialogService.open(AddMealComponent, {
			header: "Add Meal",
			width: "fit-content",
			data: {
				//INSERT Custom Data here
				SelectedPerson: this.SelectedPerson,
				user: this.user,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.onRowUnselect(null);
				this.loadResult();
			}
		});
	}

	onDeposit() {}
	onPay() {}
	onRefund() {}
	onAdjust() {}
	onDelete() {}
	onView() {}
	onPrint() {}

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Events
	////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";
		this.SelectedResult = val.data;
	}
	onRowUnselect(val) {
		this.SelectedResult = null;
	}
	onRowDblClick(Result) {
		this.errorMessage = "";
		this.SelectedResult = Result;
	}
	////////////////////////////////////////////

	////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////

	IsLoading() {
		return this.loading == true || this.processing == true;
	}

	////////////////////////////////////////////
}
